//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import eventBus from '@/util/eventBus';
import { setUrlParam } from '@tencent/vft-common/util';
import PayPop from '../Pop/PayPop/PayPop.vue';
export default {
  data: function data() {
    return {
      showPop: false
    };
  },
  components: {
    PayPop: PayPop
  },
  methods: {
    showPay: function showPay() {
      var vm = this;

      if (!this.loginService.isLogin) {
        this.loginService.openLogin();
        return;
      }

      if (this.page === 'live') {
        this.openUrl(setUrlParam('page', 'pay', window.location.href));
        return;
      }

      if (!this.vipService.isVip) {
        this.confirm({
          title: '开通会员享优惠',
          msg: '您还不是会员，开通会员后每份影票最多可省12元/份。',
          cancelText: '以原价购买',
          cancel: function cancel() {
            vm.showPop = true;
            vm.$report.click(vm.reportData.开通弹框.原价购买);
          },
          confirmText: '立即开通',
          confirm: function confirm() {
            vm.openVip();
            vm.$report.click(vm.reportData.开通弹框.开通会员);
          }
        });
        vm.$report.expose(this.reportData.开通弹框.开通弹框);
        vm.$report.expose(this.reportData.开通弹框.原价购买);
        vm.$report.expose(this.reportData.开通弹框.开通会员);
        return;
      }

      this.showPop = true;
    }
  },
  created: function created() {
    eventBus.$on('showPayPop', this.showPay);
  }
};